import { faChevronDown, faChevronUp } from '@fortawesome/pro-solid-svg-icons';

/**
 * # swContact
 * A directive which can be used to show a list of contacts.
 */
angular.module('coreModule').directive('swContact', ($log: ng.ILogService) => ({
  require: '^^swList',
  template: require('../../views/sw-contact.html').default,
  restrict: 'E',

  link: function postLink(scope: any, element, attrs, swListCtl) {
    if (!!swListCtl) {
      scope.removeItem = swListCtl.removeItem;
    }

    scope.faChevronDown = faChevronDown;
    scope.faChevronUp = faChevronUp;

    if (angular.isDefined(scope.$parent.item)) {
      // Contact embeded in an sw-list
      scope.contact = scope.$parent.item;
    } else {
      // Component not used properly, don't display
      scope.contact = null;
      $log.error('sw-contact must be used in an sw-list!');
    }
  },
}));
